import { Routes, Route, Navigate } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { useArcheAdmin } from '@/auth/hooks/useArcheAdmin';
import { GameStateListPage } from './GameStateListPage';
import { GameStateDetailPage } from './GameStateDetailPage';
import { AdminDashboardPage } from './AdminDashboardPage';
import { AdminUserLookupPage } from './AdminUserLookupPage';
import { AdminUserStatesPage } from './AdminUserStatesPage';
import { AdminUserStateDetailPage } from './AdminUserStateDetailPage';
import { AdminAuditLogPage } from './AdminAuditLogPage';
import { AdminGrantsPage } from './AdminGrantsPage';
import { AdminGrantDetailPage } from './AdminGrantDetailPage';
import { ConfigListPage } from './ConfigListPage';
import { ConfigDetailPage } from './ConfigDetailPage';

export function DfeGameStateArchePage() {
  // Server route gate: `requireAdminOrLitcraftAdmin` (docs/api-admin.md).
  const isAdmin = useArcheAdmin('litcraft_admin');

  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<GameStateListPage />} />
        <Route path="/:keyword" element={<GameStateDetailPage />} />
        {isAdmin ? (
          <>
            <Route path="/admin" element={<AdminDashboardPage />} />
            <Route path="/admin/users" element={<AdminUserLookupPage />} />
            <Route path="/admin/users/:username" element={<AdminUserStatesPage />} />
            <Route path="/admin/users/:username/:keyword" element={<AdminUserStateDetailPage />} />
            <Route path="/admin/audit" element={<AdminAuditLogPage />} />
            <Route path="/admin/grants" element={<AdminGrantsPage />} />
            <Route
              path="/admin/grants/:archeId/:resourceType/:resourceName"
              element={<AdminGrantDetailPage />}
            />
            <Route path="/admin/config" element={<ConfigListPage />} />
            <Route path="/admin/config/:keyword" element={<ConfigDetailPage />} />
          </>
        ) : (
          <Route path="/admin/*" element={<Navigate to="/" replace />} />
        )}
      </Routes>
    </ArcheLayout>
  );
}
